(function() {
  const sizeChartEl = document.getElementById('dynamic-size-chart');
  const source = sizeChartEl.getAttribute('data-file');
  fetch(source)
  .then(response => response.text())
  .then(data => {
    const board_data = data.split(/\r?\n|\r/);
    let table_data = '<table class="responsive-table table table-bordered table-striped" border="0">';
    let table_headings = [];
    for(var count = 0; count<board_data.length; count++) {
      var cell_data = board_data[count].split(",");
      table_data += '<tr>';
      for(var cell_count=0; cell_count<cell_data.length; cell_count++) {
        if(count === 0) {
          table_data += '<th>'+cell_data[cell_count]+'</th>';
          table_headings.push(cell_data[cell_count]);
        } else {

          table_data += '<td data-label="'+table_headings[cell_count]+'"><span>'+cell_data[cell_count]+'</span></td>';
        }
      }
      table_data += '</tr>';
    }
    table_data += '</table>';
    
    sizeChartEl.innerHTML = table_data;
  });
})();
/*
if($('#dynamic-size-chart').length) {
  var source = $('#dynamic-size-chart').data('file');
  $.ajax({
    url:source,
    dataType:"text",
    success:function(data) {
      var board_data = data.split(/\r?\n|\r/);
      var table_data = '<table class="responsive-table table table-bordered table-striped" border="0">';
      var table_headings = [];
      for(var count = 0; count<board_data.length; count++) {
        var cell_data = board_data[count].split(",");
        table_data += '<tr>';
        for(var cell_count=0; cell_count<cell_data.length; cell_count++) {
          if(count === 0) {
            table_data += '<th>'+cell_data[cell_count]+'</th>';
            table_headings.push(cell_data[cell_count]);
          } else {

            table_data += '<td data-label="'+table_headings[cell_count]+'"><span>'+cell_data[cell_count]+'</span></td>';
          }
        }
        table_data += '</tr>';
      }
      table_data += '</table>';
      $('#dynamic-size-chart').html(table_data);
    }
  });
}
*/